import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { AuxiliarySubscriptionResponse } from "@circle-react/types/UsageBilling";

const AUXILIARY_SUBSCRIPTION_CACHE_TIME = 1000 * 60 * 60;
const AUXILIARY_SUBSCRIPTION_STALE_TIME = 1000 * 60 * 10;

export const useAuxiliarySubscriptionApi = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = Boolean(currentCommunityMember?.is_admin);

  const {
    data: auxiliarySubscription,
    isLoading: isAuxiliarySubscriptionLoading,
    error: errorFetchingAuxiliarySubscription,
    refetch: refetchAuxiliarySubscription,
    isRefetching: isRefetchingAuxiliarySubscription,
  } = useQuery<AuxiliarySubscriptionResponse>({
    queryKey: ["communities", "billing", "auxiliary-subscription"],
    queryFn: () =>
      reactQueryGet<AuxiliarySubscriptionResponse>(
        internalApi.communities.billing.auxiliarySubscription.show(),
      ),
    retry: 2,
    enabled: isAdmin,
    cacheTime: AUXILIARY_SUBSCRIPTION_CACHE_TIME,
    staleTime: AUXILIARY_SUBSCRIPTION_STALE_TIME,
  });

  return {
    auxiliarySubscription,
    storageBilling: auxiliarySubscription?.storage ?? null,
    emailHubBilling: auxiliarySubscription?.email_hub ?? null,
    aiActionsBilling: auxiliarySubscription?.ai_actions ?? null,
    isAuxiliarySubscriptionLoading,
    errorFetchingAuxiliarySubscription,
    refetchAuxiliarySubscription,
    isRefetchingAuxiliarySubscription,
  };
};
